import React from 'react'

type InfoCardProps = {
  iconSrc: string
  title: string
  content: string
  textColor?: string
}

const InfoCard: React.FC<InfoCardProps> = ({
  iconSrc,
  title,
  content,
  textColor = 'text-gray-800',
}) => {
  return (
    <div className=" rounded-2xl shadow-[-6px_-1px_1px_rgba(240,219,219,0.8)] p-6  border border-transparent lg:w-[400px] w-full bg-transparent">
      <div className="mb-4">
        <img src={iconSrc} alt={title} className="w-10 h-10 object-contain " />
      </div>
      <h3 className={`text-xl font-bold mb-3 ${textColor}`}>{title}</h3>
      <p className="text-base text-gray-900 leading-relaxed">{content}</p>
    </div>
  )
}

export default InfoCard
